import { Component, inject, input } from '@angular/core';
import { AppConfig } from '../../../appconfig';

@Component({
  selector: 'lfw-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  standalone: true,
  imports: []
})
export class LogoComponent {
  readonly showVersion = input(false);
  private readonly config = inject(AppConfig);

  get longVersion(): string {
    return 'Version ' + this.config.displayVersion();
  }

  get shortVersion(): string {
    return 'V' + this.config.displayVersion();
  }
}
